var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginMobileRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 396.15 239.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2{fill:none;}.cls-2,.cls-3,.cls-4{stroke-width:0px;}.cls-3{fill:#cdf1f3;}.cls-4{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 396.15,
    height: 239.02
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.05-294.7c0-15.07,12.21-27.28,27.28-27.28l968.5-.15c9.23,0,18.01,4,24.05,10.98l49.03,56.54c5.72,6.61,8.89,15.05,8.89,23.8l.24,252.29c0,9.76-3.47,19.21-9.82,26.63l-47.28,55.31c-6.05,7.08-14.89,11.15-24.2,11.15H81.33c-15.07,0-27.28-12.21-27.28-27.28v-381.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.91,155.28c0-15.07,12.21-27.28,27.28-27.28l968.5-.15c9.23,0,18.01,4,24.05,10.98l49.03,56.54c5.72,6.61,8.89,15.05,8.89,23.8l.24,252.29c0,9.76-3.47,19.21-9.82,26.63l-47.28,55.31c-6.05,7.08-14.89,11.15-24.2,11.15H78.2c-15.07,0-27.28-12.21-27.28-27.28V155.28Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMobileRight);
export default __webpack_public_path__ + "static/media/login-mobile-right.a3916a942fdf1cffab897d7840c592f6.svg";
export { ForwardRef as ReactComponent };